import React, { forwardRef, useEffect } from 'react';
import './dateInput.css';

interface DateInputProps {
    value: string;
    onChange: (value: string) => void;
    placeholder?: string;
    disabled?: boolean;
    width?: number;
    height?: number;
}

const DateInput = forwardRef<HTMLInputElement, DateInputProps>(({
    value,
    onChange,
    placeholder,
    disabled = false,
    width,
    height = 30,
}, ref) => {

    // Set the default value if no value is provided and defaultValue exists
    useEffect(() => {
        if (!value && placeholder) {
            onChange(placeholder);
        }
    }, [placeholder, value, onChange]);

    return (
        <input
            ref={ref}
            type="date"
            value={value || ''}
            onChange={(e) => onChange(e.target.value)}
            className="dateInput-inputField"
            disabled={disabled}
            style={{ 
                width: width ? `${width}px` : '100%', 
                height: `${height}px` 
            }}
        />
    );
});

DateInput.displayName = 'DateInput';

export default DateInput;